import _round from 'lodash-es/round';
import { redToGreenGradientContrasted } from './redToGreenGradientContrasted';

export function getContrastBasedOnIndex(
  index: number,
  totalCount: number,
): string {
  if (totalCount <= 1) {
    return redToGreenGradientContrasted[
      redToGreenGradientContrasted.length - 1
    ];
  }

  const gradientIndex = _round(
    (index * (redToGreenGradientContrasted.length - 1)) / (totalCount - 1),
  );
  return redToGreenGradientContrasted[gradientIndex];
}
